// ** React Imports
import { useState, Fragment } from "react";
import styled from "styled-components";
import Typography from "../../../components/Typography/Typography";
import { BiError } from "react-icons/bi";
// import { GiSellCard } from "react-icons/gi";

// ** Reactstrap Imports
import {
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Button,
  ListGroup,
  ListGroupItem,
} from "reactstrap";

// ** Third Party Imports
import { useDropzone } from "react-dropzone";
import { FileText, X, DownloadCloud } from "react-feather";

const FileUploaderSingle = ({ files, setFiles }) => {
  // ** State
  const [ErrorUpload, setErrorUpload] = useState({
    isActive: false,
    message: "",
  });

  const { getRootProps, getInputProps } = useDropzone({
    multiple: false,
    onDrop: (acceptedFiles) => {
      setFiles(
        ...acceptedFiles.map((file) => {
          if (
            (file.type !== "image/png" &&
              file.type !== "image/jpg" &&
              file.type !== "image/jpeg") ||
            file.size > 0.8e6
          ) {
            file.size > 0.8e6
              ? setErrorUpload({
                  isActive: true,
                  message: "فایل انتخاب شده بیشتر از 800 مگ است",
                })
              : setErrorUpload({
                  isActive: true,
                  message: "فایل انتخاب شده صحیح نیست",
                });
          } else {
            setErrorUpload({
              isActive: false,
              message: "فایل انتخاب شده بیشتر از 800 مگ است",
            });
            return Object.assign(file);
          }
        })
      );
    },
  });

  const renderFilePreview = (file) => {
    if (file.type.startsWith("image")) {
      return (
        <img
          className="rounded ms-4"
          alt={file.name}
          src={URL.createObjectURL(file)}
          height="100%"
          width="100%"
          style={{ objectFit: "cover" }}
        />
      );
    } else {
      return <FileText size="28" />;
    }
  };

  const handleRemoveFile = (file) => {
    const uploadedFiles = files;
    setFiles();
  };

  const renderFileSize = (size) => {
    if (Math.round(size / 100) / 10 > 1000) {
      return `${(Math.round(size / 100) / 10000).toFixed(1)} mb`;
    } else {
      return `${(Math.round(size / 100) / 10).toFixed(1)} kb`;
    }
  };

  const handleRemoveAllFiles = () => {
    setFiles();
  };

  return (
    <CardStyle>
      <CardBody>
        <div {...getRootProps({ className: "dropzone up-img" })}>
          <input {...getInputProps()} />
          <div className="d-flex align-items-center justify-content-center flex-column up-img">
            <DownloadCloud size={24} />
            <Typography size="14px">
              فایل خود را اینجا رها کنید یا کلیک کنید
            </Typography>
          </div>
        </div>
        {files ? (
          <Fragment>
            <ListGroup className="my-2">
              <ListGroupItem
                key={`${files?.name}-${1}`}
                className="d-flex align-items-center justify-content-between"
              >
                <div className="file-details d-flex align-items-center flex-column">
                  <div className="file-preview me-1 mb-4">
                    {renderFilePreview(files)}
                  </div>
                  <div>
                    <Typography size="11px">
                      {files?.name?.slice(0, 20)}
                    </Typography>
                    <Typography size="11px">
                      {renderFileSize(files?.size)}
                    </Typography>
                  </div>
                </div>
              </ListGroupItem>
            </ListGroup>
            <div className="d-flex justify-content-end">
              <Button
                className="me-1"
                color="danger"
                outline
                onClick={handleRemoveAllFiles}
              >
                حذف فایل
              </Button>
            </div>
          </Fragment>
        ) : null}
        {ErrorUpload.isActive && (
          <Fragment>
            <Typography primary="red" className="mt-4" size="10px">
              {ErrorUpload.message}
            </Typography>
            <BiError color="red" />
          </Fragment>
        )}
      </CardBody>
    </CardStyle>
  );
};

export const CardStyle = styled.div`
  width: 80%;
  border-radius: 1rem;
  margin: 1rem;
  border: 2px dotted #50cd89;
  overflow: hidden;

  .up-img {
    cursor: pointer;
  }
`;

export default FileUploaderSingle;
